export default "__VITE_ASSET__DDC0wDg6__ 640w, __VITE_ASSET__Cxsk2tRY__ 1024w, __VITE_ASSET__DtxjvUcR__ 1672w";